import { render, staticRenderFns } from "./QuestionButton.vue?vue&type=template&id=6809f569&scoped=true&"
import script from "./QuestionButton.vue?vue&type=script&lang=ts&"
export * from "./QuestionButton.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionButton.vue?vue&type=style&index=0&id=6809f569&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809f569",
  null
  
)

export default component.exports